module.exports = __webpack_public_path__ + "img/thumbnail_Okapi_f_normal.449c1bf8.png";